<template>
  <div class="modal2">
    <Transition name="bounce">
      <div class="box" v-if="showC">
        <div class="top">
          <div class="title">Calculadora</div>
          <div class="total-box">
            <div class="total"><div class="icon-moeda"></div> {{ store.totalValCalc() }}</div>
            <div class="remove" @click="store.clearVal()">
              <lord-icon
                src="https://cdn.lordicon.com/jmkrnisz.json"
                trigger="morph"
                colors="primary:#e83a30"
                state="hover-empty"
                style="width:20px;height:20px"></lord-icon>
            </div>
          </div>
          <div class="close" @click="showC = false"><i class="fa-solid fa-xmark"></i></div>
        </div>
        <div class="content">
          <TransitionGroup name="fade">
            <div class="mob" v-for="(_, index) in store.valCart" :key="index">
              <div class="icon" :style="{backgroundImage: 'url('+store.valCart[index].item.icon+')'}"></div>
              <div>
                <div class="title nobr">{{ store.valCart[index].item.mob }}</div>
                <!-- <div class="qty">Quantidade: {{ this.store.qtyVal(t.id) }}</div> -->
                <div class="qty">Quantidade: {{ store.valCart[index].quantity }}</div>
              </div>
              <div class="remove" @click="store.removeItemCalc(index)"><i class="fa-solid fa-trash"></i>
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
      <div class="btnCart" v-else @click="showC = true" :class="{active: store.totalValCalc() !== 0}">
        <lord-icon src="https://cdn.lordicon.com/ausvvtws.json" colors="primary:#545454" trigger="hover"
                   style="width:26px;height:26px"></lord-icon>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { useStore } from '@/stores/index.js'
import { ref } from 'vue'

const store = useStore()

// const valView = ref([])
const showC = ref(false)

</script>

<style scoped>

@keyframes bounce-in {
  0% {
    right: -200px;
  }
  100% {
    right: 20px;
    bottom: 20px;
  }
}

.modal2 {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99;
}

@media (max-width: 1199px) {
  .modal2 {
    bottom: 160px;
  }
}

.modal2 .btnCart {
  position: relative;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50px;
  text-align: center;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
}

.modal2 .btnCart.active {
  animation: btn .6s ease-in;
}

@keyframes btn {
  0% {
    bottom: 10px;
  }
  30% {
    bottom: 0;
  }
  60% {
    bottom: 10px;
  }
  100% {
    bottom: 0;
  }
}

.modal2 .box {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 300px;
  height: auto;
  background-color: #fff;
  border-radius: 12px;
  z-index: 9;
}

.modal2 .top {
  position: relative;
  float: left;
  width: 100%;
  height: 50px;
  border-bottom: 2px solid rgba(0, 0, 0, .1);
  padding: 10px;
  user-select: none;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
}

.modal2 .top .title {
  float: left;
  width: auto;
  height: 24px;
  font-size: 20px;
  font-weight: 800;
  color: #050505;
  margin-top: 4px;
  padding: 0 0;
}

.modal2 .top .total-box {
  position: relative;
  display: flex;
  width: auto;
  height: 40px;
  border-radius: 40px;
  background-color: #eee;
  line-height: 20px;
  margin: -5px 40px 0 0;
}

.modal2 .top .total-box .total {
  float: left;
  min-width: 40px;
  width: auto;
  height: 100%;
  border-radius: 50px;
  padding: 10px 6px;
  background-color: #bbb;
  color: #444;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

.modal2 .top .total-box .remove {
  position: relative;
  padding: 10px 6px 0 2px;
}

.modal2 .top .close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  color: #A7A7A7;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  user-select: none;
}

.modal2 .content {
  width: 100%;
  height: auto;
  max-height: 350px;
  overflow-y: auto;
  padding: 8px;
}

.modal2 .content .mob {
  float: left;
  width: 100%;
  height: 60px;
  margin-top: 6px;
  background-color: #eee;
  border-radius: 12px;
  padding: 4px;
  display: flex;
  justify-content: space-between;
}

.modal2 .content .mob .icon {
  width: 50px;
  height: 100%;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
}

.icon-moeda {
  float: left;
  width: 15px;
  height: 15px;
  background-image: url('@/assets/asinha.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 2px 5px 0 0;
}

.modal2 .content .mob div:nth-child(2) {
  width: 74%;
}

.modal2 .content .mob .title,
.modal2 .content .mob .qty {
  float: left;
  width: 100%;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  padding-left: 6px;
  margin-top: 8px;
}

.modal2 .content .mob .qty {
  font-size: 13px;
  font-weight: 400;
  margin-top: 4px;
}

.modal2 .content .mob .remove {
  width: 20px;
  height: 20px;
  margin: 16px 0 0 0;
  font-size: 14px;
  color: #444;
}

</style>